export default "__VITE_ASSET__CLJMi3lB__"